import { MIME_TYPE_MAP } from './constants';
export default function toMimeType(ext) {
    if (ext.startsWith('.')) {
        return ext;
    }
    return MIME_TYPE_MAP[ext] || ext;
}
